// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';
import AddressAutocompleteController from './address_autocomplete_controller';
import BulkActionController from './bulk_action_controller';
import ClipboardController from './clipboard_controller';
import ConditionalInputController from './conditional_input_controller';
import FiltersCountController from './filters_count_controller';
import FindOrCreateFormController from './find_or_create_form_controller';
import InputFilesController from './input_files_controller';
import MillionNumberFormatterController from './million_number_formatter_controller';
import NarrowSearchController from './narrow_search_controller';
import NestedFormController from './nested_form_controller';
import OffcanvasFormController from './offcanvas_form_controller';
import PhoneInputController from './phone_input_controller';
import RansackPredicateSelectController from './ransack_predicate_select_controller';
import RedactorController from './redactor_controller';
import TabsController from './tabs_controller';
import TemplateChoiceController from './template_choice_controller';
import ToastController from './toast_controller';
import TodolistController from './todolist_controller';
import ToggleDisplayPasswordController from './toggle_display_password_controller';
import TomSelectController from './tom_select_controller';
import TooltipController from './tooltip_controller';
import UploadController from './upload_controller';
import ChartController from './chart_controller';
import DataroomNdaModalController from './dataroom_nda_modal_controller';
import MultipleTabsController from './multiple_tabs_controller';
import FormController from './form_controller';
import PdfReaderController from './pdf_reader_controller';
import BirthdayController from './birthday_controller';
import QuestionController from './question_controller';
import ModalController from './modal_controller';
import QuestionCardController from './question_card_controller';
import PagyController from './pagy_controller';
import FinancingOptionsTableController from './financing_options_table_controller';
import FrameRefreshController from './frame_refresh_controller';
import FrameResetController from './frame_reset_controller';
import DataroomDropzoneController from './dataroom_dropzone_controller';
import ImportWindowController from './import_window_controller';

application.register('nested-form', NestedFormController);
application.register('find-or-create-form', FindOrCreateFormController);
application.register('redactor', RedactorController);
application.register(
  'million-number-formatter',
  MillionNumberFormatterController
);
application.register(
  'ransack-predicate-select',
  RansackPredicateSelectController
);
application.register('address-autocomplete', AddressAutocompleteController);
application.register('tom-select', TomSelectController);
application.register('toast', ToastController);
application.register('template-choice', TemplateChoiceController);
application.register('tabs', TabsController);
application.register('phone-input', PhoneInputController);
application.register('offcanvas-form', OffcanvasFormController);
application.register('upload', UploadController);
application.register('todolist', TodolistController);
application.register('conditional-input', ConditionalInputController);
application.register('tooltip', TooltipController);
application.register('input-files', InputFilesController);
application.register(
  'toggle-display-password',
  ToggleDisplayPasswordController
);
application.register('narrow-search', NarrowSearchController);
application.register('filters-count', FiltersCountController);
application.register('chart', ChartController);
application.register('dataroom-nda-modal', DataroomNdaModalController);
application.register('multiple-tabs', MultipleTabsController);
application.register('form', FormController);
application.register('pdf-reader', PdfReaderController);
application.register('birthday', BirthdayController);
application.register('question', QuestionController);
application.register('modal', ModalController);
application.register('bulk-action', BulkActionController);
application.register('question-card', QuestionCardController);
application.register('pagy', PagyController);
application.register('clipboard', ClipboardController);
application.register('financing-options-table', FinancingOptionsTableController);
application.register('frame-refresh', FrameRefreshController);
application.register('frame-reset', FrameResetController);
application.register('dataroom-dropzone', DataroomDropzoneController);
application.register('import-window', ImportWindowController);
